var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.status_login === "T"
    ? _c(
        "v-layout",
        {
          staticStyle: { overflow: "hidden !important" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            {
              staticClass: "setBgHeader widthfull",
              style: { background: _vm.backgroudHeader },
              attrs: { xs12: "" }
            },
            [
              _c(
                "h3",
                {
                  staticClass: "centerDiv mt-1",
                  staticStyle: { color: "white" }
                },
                [_vm._v("แชทกับเรา")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticStyle: { background: "white !important" },
              attrs: { xs12: "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "headername widthfull",
                      attrs: { xs12: "" }
                    },
                    [
                      _c(
                        "v-avatar",
                        { staticClass: "f-l mr-2 user-photoprofilechat" },
                        [
                          _c("img", {
                            staticClass: "alligator-turtle",
                            attrs: {
                              src: "/static/img/call-center.png",
                              alt: "John"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticStyle: { "padding-top": "12px" },
                          attrs: { row: "", wrap: "", "align-center": "" }
                        },
                        [
                          _c("h4", { staticStyle: { "margin-left": "1vw" } }, [
                            _vm._v("หัวข้อปัญหา : " + _vm._s(_vm.subject))
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "setHeightChatBox",
                      attrs: { xs12: "", id: "myscroll" },
                      on: { scroll: _vm.scrollFunction }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modalc", attrs: { id: "myModal" } },
                        [
                          _c(
                            "div",
                            { attrs: { id: "headcaption" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "align-center": "",
                                        "justify-end": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            md12: "",
                                            sm12: "",
                                            xl12: "",
                                            lg12: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "close",
                                              on: {
                                                click: function($event) {
                                                  return _vm.closemodal()
                                                }
                                              }
                                            },
                                            [_vm._v("×")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "modal-contentc",
                            attrs: { id: "img01" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modalc", attrs: { id: "myModalFile" } },
                        [
                          _c(
                            "div",
                            { attrs: { id: "headcaption" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "align-center": "",
                                        "justify-end": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            md12: "",
                                            sm12: "",
                                            xl12: "",
                                            lg12: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "close",
                                              on: {
                                                click: function($event) {
                                                  return _vm.closemodal()
                                                }
                                              }
                                            },
                                            [_vm._v("×")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("iframe", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "justify-content": "center"
                            },
                            attrs: { src: _vm.filepdf, frameborder: "0" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.listmessage, function(item, index) {
                        return _c(
                          "v-layout",
                          { key: item.id, attrs: { row: "", wrap: "" } },
                          [
                            _c(
                              "v-layout",
                              {
                                staticStyle: { "margin-bottom": "15px" },
                                attrs: {
                                  row: "",
                                  wrap: "",
                                  "align-center": "",
                                  "justify-center": ""
                                }
                              },
                              [
                                index == 0
                                  ? _c("div", [
                                      _vm.statusload
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "text-xs-center",
                                              on: { click: _vm.loadchathistory }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticStyle: {
                                                    background:
                                                      "#ff000000 !important",
                                                    "text-transform": "none",
                                                    "font-size": "12px"
                                                  },
                                                  attrs: {
                                                    small: "",
                                                    round: "",
                                                    outline: "",
                                                    color: "primary"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticStyle: {
                                                        "font-size":
                                                          "16px !important"
                                                      },
                                                      attrs: { left: "" },
                                                      on: {
                                                        click:
                                                          _vm.loadchathistory
                                                      }
                                                    },
                                                    [_vm._v("refresh")]
                                                  ),
                                                  _vm._v("โหลดข้อความก่อนหน้า")
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.tokenroom === item.room
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "conversation-start",
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.momentdate(item.date)
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  : item.date !==
                                    _vm.listmessage[index - 1].date
                                  ? _c(
                                      "div",
                                      [
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xl12: "",
                                              md12: "",
                                              sm12: "",
                                              lg12: ""
                                            }
                                          },
                                          [
                                            _vm.tokenroom === item.room
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "conversation-start",
                                                    staticStyle: {
                                                      "text-align": "center"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.momentdate(
                                                            item.date
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            item.type == "admin"
                              ? _c(
                                  "v-flex",
                                  {
                                    attrs: { xs12: "", "ml-3": "", "mb-2": "" }
                                  },
                                  [
                                    _c(
                                      "v-avatar",
                                      { staticClass: "f-l mr-2" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "/static/img/call-center.png",
                                            alt: "John"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-tooltip", { attrs: { right: "" } }, [
                                      item.typemessage === "message"
                                        ? _c("div", {
                                            staticClass: "chatBoxFriend f-l",
                                            attrs: { slot: "activator" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm
                                                  .convert(item.msg)
                                                  .replace(
                                                    /(?:\r\n|\r|\n)/g,
                                                    "<br>"
                                                  )
                                              )
                                            },
                                            slot: "activator"
                                          })
                                        : item.typemessage === "image"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "chatBoxFriend f-l",
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "imageChat",
                                                staticStyle: {
                                                  cursor: "pointer"
                                                },
                                                attrs: { src: item.msg },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.zoom(
                                                      item.msg,
                                                      item.filename,
                                                      item.chatname,
                                                      item.profilepicture,
                                                      item.date,
                                                      item.timestamp,
                                                      item.tokenmessage,
                                                      item.type
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        : item.typemessage === "file"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "chatBoxFriend f-l",
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _vm.extension(item.filename) ===
                                              "pdf"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        cursor: "pointer"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.zoomfile(
                                                            item.msg,
                                                            item.filename,
                                                            item.chatname,
                                                            item.profilepicture,
                                                            item.date,
                                                            item.timestamp,
                                                            item.tokenmessage,
                                                            item.type
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("pdf", {
                                                        ref: "myPdfComponent",
                                                        refInFor: true,
                                                        attrs: {
                                                          src: item.msg,
                                                          page: 1
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "textfile"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.filename
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "mp4"
                                                ? _c("div", [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          width: "150",
                                                          height: "170",
                                                          controls: ""
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "video/mp4"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "wmv"
                                                ? _c("div", [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          width: "150",
                                                          height: "170",
                                                          controls: ""
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "video/wmv"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "ogg"
                                                ? _c("div", [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          width: "150",
                                                          height: "170",
                                                          controls: ""
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "video/ogg"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "acc"
                                                ? _c("div", [
                                                    _c(
                                                      "audio",
                                                      {
                                                        staticStyle: {
                                                          width:
                                                            "150px !important",
                                                          height:
                                                            "60px !important"
                                                        },
                                                        attrs: { controls: "" }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "audio/acc"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "wav"
                                                ? _c("div", [
                                                    _c(
                                                      "audio",
                                                      {
                                                        staticStyle: {
                                                          width:
                                                            "150px !important",
                                                          height:
                                                            "60px !important"
                                                        },
                                                        attrs: { controls: "" }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "audio/wav"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "iconfile"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.extension(
                                                                item.filename
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "textfile"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.filename
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "chatBoxFriend f-l",
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _vm._v(
                                                "\n              ข้อความนี้ไม่รองรับในเวอร์ชันนี้\n            "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.momenttime(item.timestamp))
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              : item.type == "guest"
                              ? _c(
                                  "v-flex",
                                  {
                                    attrs: { xs12: "", "mr-3": "", "mb-2": "" }
                                  },
                                  [
                                    _c("v-tooltip", { attrs: { left: "" } }, [
                                      item.typemessage === "message"
                                        ? _c("div", {
                                            staticClass: "chatBox f-r",
                                            style: { background: _vm.chatbox },
                                            attrs: { slot: "activator" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm
                                                  .convert(item.msg)
                                                  .replace(
                                                    /(?:\r\n|\r|\n)/g,
                                                    "<br>"
                                                  )
                                              )
                                            },
                                            slot: "activator"
                                          })
                                        : item.typemessage === "image"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "chatBox f-r",
                                              style: {
                                                background: _vm.chatbox
                                              },
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "imageChat",
                                                staticStyle: {
                                                  cursor: "pointer"
                                                },
                                                attrs: { src: item.msg },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.zoom(
                                                      item.msg,
                                                      item.filename,
                                                      item.chatname,
                                                      item.profilepicture,
                                                      item.date,
                                                      item.timestamp,
                                                      item.tokenmessage,
                                                      item.type
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        : item.typemessage === "file"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "chatBox f-r",
                                              style: {
                                                background: _vm.chatbox
                                              },
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _vm.extension(item.filename) ===
                                              "pdf"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        cursor: "pointer"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.zoomfile(
                                                            item.msg,
                                                            item.filename,
                                                            item.chatname,
                                                            item.profilepicture,
                                                            item.date,
                                                            item.timestamp,
                                                            item.tokenmessage,
                                                            item.type
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("pdf", {
                                                        ref: "myPdfComponent",
                                                        refInFor: true,
                                                        attrs: {
                                                          src: item.msg,
                                                          page: 1
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "textfile"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.filename
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "mp4"
                                                ? _c("div", [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          width: "150",
                                                          height: "170",
                                                          controls: ""
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "video/mp4"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "wmv"
                                                ? _c("div", [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          width: "150",
                                                          height: "170",
                                                          controls: ""
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "video/wmv"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "ogg"
                                                ? _c("div", [
                                                    _c(
                                                      "video",
                                                      {
                                                        attrs: {
                                                          width: "150",
                                                          height: "170",
                                                          controls: ""
                                                        }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "video/ogg"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "acc"
                                                ? _c("div", [
                                                    _c(
                                                      "audio",
                                                      {
                                                        staticStyle: {
                                                          width:
                                                            "150px !important",
                                                          height:
                                                            "60px !important"
                                                        },
                                                        attrs: { controls: "" }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "audio/acc"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm.extension(
                                                    item.filename
                                                  ) === "wav"
                                                ? _c("div", [
                                                    _c(
                                                      "audio",
                                                      {
                                                        staticStyle: {
                                                          width:
                                                            "150px !important",
                                                          height:
                                                            "60px !important"
                                                        },
                                                        attrs: { controls: "" }
                                                      },
                                                      [
                                                        _c("source", {
                                                          attrs: {
                                                            src: item.msg,
                                                            type: "audio/wav"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "iconfile"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.extension(
                                                                item.filename
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "textfile"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.filename
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "chatBox f-r",
                                              style: {
                                                background: _vm.chatbox
                                              },
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _vm._v(
                                                "\n              ข้อความนี้ไม่รองรับในเวอร์ชันนี้\n            "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.momenttime(item.timestamp))
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _vm.status_room !== "close"
                      ? _c(
                          "div",
                          { staticClass: "textBox" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    attrs: { xs12: "", "pl-2": "", "pt-1": "" }
                                  },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.msg,
                                          expression: "msg"
                                        }
                                      ],
                                      staticClass: "widthfull",
                                      attrs: {
                                        rows: "2",
                                        cols: "50",
                                        placeholder: "พิมพ์ข้อความของคุณที่นี่"
                                      },
                                      domProps: { value: _vm.msg },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.sendMessage(_vm.msg)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.msg = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "texboxdisabled" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    attrs: { xs12: "", "pl-2": "", "pt-1": "" }
                                  },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.msg,
                                          expression: "msg"
                                        }
                                      ],
                                      staticClass: "widthfull",
                                      attrs: {
                                        rows: "2",
                                        cols: "50",
                                        placeholder: "ไม่สามารถพิมพ์ข้อความได้",
                                        disabled: ""
                                      },
                                      domProps: { value: _vm.msg },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.sendMessage(_vm.msg)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.msg = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        "align-center": "",
                        "justify-center": "",
                        row: "",
                        wrap: ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs8: "", "pl-2": "" } },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                "align-center": "",
                                "justify-start": "",
                                row: "",
                                wrap: ""
                              }
                            },
                            [
                              _c("Menusetting", {
                                on: { pushfile: _vm.pushfile, sound: _vm.sound }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "colorFooterMenu" }, [
                                _vm._v("สวัสดีคุณ :")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "textname" }, [
                                _vm._v(_vm._s(_vm.name))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "", "pr-2": "" } },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                "align-center": "",
                                "justify-end": "",
                                row: "",
                                wrap: ""
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticStyle: { "font-size": "10px" },
                                  attrs: {
                                    href: "https://chat.one.th/",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Power by One Chat")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fa2e3d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa2e3d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatBox.vue
// module id = null
// module chunks = 